import { LegendExclusions } from './sl-layer_legend-exclusions';
import { GeoLoc } from './../types/@types/sl-v-types.d';
import { RenderedLayer } from './../types/layerrenderresult';
import { Decorable } from '../types/decorable';
import {
  LayerAttributesArray,
  LayerExportOptionsArray,
  BBOXArray,
  ILayerApiService,
  ILayerOverlay,
  AnyHandler,
  AttributeInfo
} from '../types/@types/sl-v-types';
import { ISLMap } from '../types/@types/sl-map';

import { CancellablePromise } from '../types/cancellable-promise';

import { SLMap } from './sl-map';
import { LayerRenderResult } from '../types/layerrenderresult';
import { EventEmitter, Output } from '@angular/core';
import { LabelStyle } from '../types/LabelStyle';
import { LayerSaveOptions, LayerLoadOptions } from './api-services/layer-api.service';
import { LayersApiService, FitSet } from './api-services/layers-api.service';
import { ColorClass } from '../types/color-class';
import { ResultsService } from '../services/results.service';
import { ISelectionData } from './synchronizer';
import { AttributesService } from './api-services/attributes.service';
import { FeatureInfo } from '../components/results-view/results-view.component';
import { SlWapiService } from './api-services/sl-wapi.service';
import { ReportingLevel, ReportingLevels } from '../types/reporting_levels';
import { InfoAction } from './map-actions/info-action';
import { NavigationAction } from './map-actions/navigation-action';
import { Point } from 'mapbox-gl';

export enum LayerAccessLevel {
  None = 0,
  Read = 1,
  Copy = 2,
  Edit = 3
}
export enum LayerTypeEnum {
  None = 0,
  Vector = 1,
  Raster = 2,
  WMS = 3,
  ODBC = 4,
  Relational = 5,
  Collection = 6,
  SmartLayer = 7,
  Relatable = 8,
  Virtual = 9000,
  Virtual_Results = 9001,
  Virtual_Input = 9002,
  Virtual_ResultBuffer = 9003,
  Virtual_SelectedResults = 9004,
  Virtual_UnSelectedResults = 9005,
  Virtual_SnapLayer = 9006



}
export enum LayerGeomtypes {
  Unkown = 0,
  Point = 1,
  Polygon = 2,
  Line = 3,
  Raster = 4,
  WMS = 5,
  Collection = 6,
  Relatable = 7
}
export type LayerGeomTypeStrings = 'unknown' | 'point' | 'polygon' | 'line' | 'raster' | 'wms' | 'collection' | 'relatable';
export type LayerLabelState = {
  labelsOn: boolean | null;
  labelAttribute: string | null;
  labelStyle: LabelStyle;
  labelOverride: string | null;
};

export class SLLayer {
  // ToDo: Permission Enforcement;
  static COLLECTION_ICON = 'font-icon';//'assets/images/layer-icons/collection.png';
  static LINE_ICON = 'assets/images/layer-icons/line.png';
  static POINT_ICON = 'assets/images/layer-icons/point.png';
  static POLYGON_ICON = 'assets/images/layer-icons/poly.png';
  static RASTER_ICON = 'assets/images/layer-icons/raster.png';
  static UNKNOWN_ICON = 'assets/images/layer-icons/unknown.png';
  static WMS_ICON = 'assets/images/layer-icons/wms.png';
  static RELATIONAL_ICON = 'assets/images/layer-icons/relational.png';
  static TYPE_TABULAR = [
    LayerTypeEnum.Vector,
    LayerTypeEnum.Relatable,
    LayerTypeEnum.Relational
  ];
  static VIRTUAL_SEARCH_RESULT_SUBLAYERS = [
    LayerTypeEnum.Virtual_Input,
    LayerTypeEnum.Virtual_ResultBuffer,
    LayerTypeEnum.Virtual_SelectedResults,
    LayerTypeEnum.Virtual_UnSelectedResults
  ];

  iconChange: EventEmitter<string> = new EventEmitter<string>();


  public data: Decorable;
  public overlayLayer: ILayerOverlay;

  protected renderPromise: CancellablePromise;
  protected _classification: Array<ColorClass> = null;
  protected count = 0;
  protected _rendering: false | string = false;
  public rendering: EventEmitter<any> = new EventEmitter();
  public rendered: EventEmitter<any> = new EventEmitter();
  public legendChange: EventEmitter<any> = new EventEmitter();
  public visChange: EventEmitter<any> = new EventEmitter();
  public layerOnChange: EventEmitter<any> = new EventEmitter();
  public deleteChange: EventEmitter<any> = new EventEmitter();
  public filterField: string = '';
  public filterIds: Array<string> | string | null = null;
  public labelOverride: string = null;
  private originalLabelState: LayerLabelState | null = null;
  protected touched = false;
  protected styles: any;
  public SLMap: ISLMap;
  public isOverlayable: boolean = true;
  protected isEnabled = true;
  protected resultsSvc: ResultsService = null;

  public exclusions: LegendExclusions = new LegendExclusions();
  public abilities: Decorable = {
    layer_vis: true,
    include_in_search: false,
    show_labels: false,
    include_in_legend: false,
    tooltip: false,
    allow_static_labels: false
  };
  public lastRender: void | CancellablePromise;
  public inputType: '' | 'rect' | 'point' | 'feature' = '';

  public change$: EventEmitter<SLLayer> = new EventEmitter();

  public get isRendering(): boolean {
    return this._rendering !== false;
  }

  public get isVector(): boolean {
    switch (this.geom) {
      case 'line':
      case 'point':
      case 'polygon':
        return true;
      default:
        return false;
    }
  }
  public get isRaster(): boolean {
    if (this.IsVirtual() === true) return false;
    return this.data.geom === 'raster;'
  }
  public get isWMS(): boolean {
    if (this.IsVirtual() === true) return false;

    return this.data.geom === 'wms';
  }
  public get isTabular(): boolean {
    return SLLayer.TYPE_TABULAR.indexOf(this.type) > -1;
  }
  get classification(): Array<ColorClass> {
    return null;
  }
  get enabled(): boolean {

    return this.isEnabled;
  }
  set enabled(isEnabled: boolean) {
    this.isEnabled = isEnabled;
    this.change$.emit(this);

  }
  get isPLayer() {
    if (this.plid !== null) {
      return true;
    }
    return !!this.map?.project;
  }
  static GetIconClass(layer: SLLayer) {
    switch (LayerTypeEnum[layer.type].toLowerCase()) {
      case 'virtual_results':
      case 'collection':
        return SLLayer.COLLECTION_ICON;
      case 'raster':
      case 'wms':
        return 'sl-layer-' + LayerTypeEnum[layer.type].toLowerCase();
    }
    return 'sl-layer-' + layer.geom?.toLowerCase();
  }
  static GetIconFromTypes(layerType: number | string, geomType: number | string) {
    switch (LayerTypeEnum[layerType].toLowerCase()) {
      case 'collection':
        return SLLayer.COLLECTION_ICON;
      /*case 'relational':
        return SLLayer.RELATIONAL_ICON;
      case 'relatable':
        return '';
        */
      case 'raster':
        return SLLayer.RASTER_ICON;
      case 'wms':
        return SLLayer.RASTER_ICON;
    }
    switch (LayerGeomtypes[+geomType].toLowerCase()) {
      case 'line':
        return SLLayer.LINE_ICON;
      case 'polygon':
        return SLLayer.POLYGON_ICON;
      case 'point':
        return SLLayer.POINT_ICON;
      case 'unknown':
      default:
        return SLLayer.UNKNOWN_ICON;
    }
  }
  static GetIcon(geomString: string = ''): string {
    switch (geomString.toLowerCase()) {
      case 'collection':
        return SLLayer.COLLECTION_ICON;
      case 'line':
        return SLLayer.LINE_ICON;
      case 'polygon':
        return SLLayer.POLYGON_ICON;
      case 'point':
        return SLLayer.POINT_ICON;
      case 'relational':
        return SLLayer.RELATIONAL_ICON;
      case 'relatable':
        return '';
      case 'raster':
        return SLLayer.RASTER_ICON;
      case 'wms':
        return SLLayer.WMS_ICON;
      case 'unknown':
      default:
        return SLLayer.UNKNOWN_ICON;
    }
  }
  static GetGids(features: Array<any>, asString = false): Array<any> | string {

    const gids = [];
    if (features.length > 0) {
      if (typeof features[0] !== 'object') {
        if (asString) {
          return features.join(',');
        }
        return features;
      }
    }

    for (const feature of features) {
      if (!!feature.gid) {
        gids.push(feature.gid);
      }
    }
    if (asString) {
      return gids.join(',');
    }
    return gids;
  }
  get map(): ISLMap {
    return this.SLMap;
  }
  get queryAble(): boolean {
    if (this.searchable === false) {
      return false;
    }
    return [
      LayerTypeEnum.Vector.valueOf(),
      LayerTypeEnum.Relational.valueOf()
    ].indexOf(+this.type) > -1;
    // return (this.access >= LayerAccessLevel.Read);
  }

  get searchable(): boolean {
    if ([
      LayerTypeEnum.Vector.valueOf(),
      LayerTypeEnum.Relational.valueOf()
    ].indexOf(+this.type) === -1) {
      return false;
    }
    return this.data.search_on === 1;
  }

  set searchable(isSearchable: boolean) {
    this.data.search_on = isSearchable === true ? 1 : 0;
    this.change$.emit(this);
  }
  get srs() {
    if (!!this.data.srs) {
      return this.data.srs;
    }
    return null;
  }
  get srsName(): string | null {
    if (!!this.data.srs) {
      const srsInfo = this.data.srs.split('[');
      srsInfo.shift();
      const name = srsInfo.join('[').split(',').shift();
      return name.substr(1, name.length - 2);
    }
    return null;
  }
  constructor(
    layerData: Decorable = null,
    map: ISLMap = null,
    protected layerService: ILayerApiService = null,
    private layersService: LayersApiService = null,
    resultsSvc: ResultsService = null,
    isOverlayable: boolean = true) {
    this.layersService = this.layersService;
    this.resultsSvc = resultsSvc;
    this.data = layerData;
    this.SLMap = map;
    this.styles = (!!this.SLMap) ? this.SLMap.styles : null;
    this.isOverlayable = isOverlayable;
    if (!!map && !!map.component) {
      this.overlayLayer = (!!this.SLMap) ? map.component.layerAPI.MakeOverlayLayer(this.SLMap, this) : null;
    } else {
      this.overlayLayer = null;
    }

    this.abilities = {
      layer_vis: true,
      include_in_search: [
        LayerTypeEnum.Vector,
        LayerTypeEnum.ODBC,
        LayerTypeEnum.Relatable,
        LayerTypeEnum.SmartLayer,
        LayerTypeEnum.Relatable
      ].indexOf(this.type) > -1,
      tooltip: [
        LayerTypeEnum.Vector,
        LayerTypeEnum.ODBC,
        LayerTypeEnum.Relatable,
        LayerTypeEnum.SmartLayer,
        LayerTypeEnum.Relatable
      ].indexOf(this.type) > -1,
      show_labels: [
        LayerTypeEnum.Vector,
        LayerTypeEnum.Relational,
        LayerTypeEnum.SmartLayer,
        LayerTypeEnum.Virtual_Results,
        LayerTypeEnum.Virtual_SelectedResults,
        LayerTypeEnum.Virtual_UnSelectedResults
      ].indexOf(this.type) > -1,
      include_in_legend: [
        LayerTypeEnum.Vector,
        LayerTypeEnum.Relational,
        LayerTypeEnum.SmartLayer,
      ].indexOf(this.type) > -1
    };
    this.CaptureLabelState();

  }
  get overlayId(): string {
    return this.overlayLayer.id;
  }
  get access(): number {
    if (this.data === null) {
      return 0;
    }
    return Number(this.data.access);
  }
  set access(accessLevel: number) {
    this.data.access = accessLevel;
    this.change$.emit(this);
  }
  get share_level(): number {
    return this.data.access;
  }
  get reporting_level(): ReportingLevel {
    return Number(this.data.reporting) as ReportingLevel;
  }
  get canExportGeom(): boolean {
    if (this.isVector === false) {
      return false;
    }
    return this.reporting_level === ReportingLevels.GEOEXPORT;
  }
  get canExportTables(): boolean {
    return this.reporting_level >= ReportingLevels.EXPORT;

  }
  set accessLabel(accessLabel: string) {
    this.data.access = LayerAccessLevel[accessLabel];
    this.change$.emit(this);
  }
  get accessLabel(): string {
    return LayerAccessLevel[this.data.access];
  }
  get adder(): string | null {
    if (this.isPLayer === false) {
      return null;
    }
    return this.data.adder;
  }
  get adderName(): string | null {
    if (this.isPLayer === false) {
      return null;
    }
    return this.data.adder_name;
  }
  get attribute(): string {
    return (this.data.attribute === null) ? '' : this.data.attribute;
  }
  set attribute(attr: string) {
    this.data.attribute = attr;
    this.change$.emit(this);
  }
  get bbox(): Array<number> {
    if (!!this.data) {
      return (this.data.bbox);
    }
    return null;
  }
  set bbox(bbox: Array<number>) {
    this.data.box = bbox;
    this.change$.emit(this);
  }
  set bboxString(bbox: string) {
    this.data.bbox = bbox.split(',');
    this.change$.emit(this);
  }
  get defaultCriteria(): Array<any> | null {
    if (this.isPLayer === false) {
      return null;
    }
    if (!!this.data.default_criteria) {
      return this.data.default_criteria.split(';');
    } else {
      return [];
    }
  }
  get description(): string {
    if (!!this.data.description) {
      return this.data.description;
    }
    return '';
  }
  set description(desc: string) {
    this.data.description = (desc === '') ? null : desc;
    this.change$.emit(this);
  }
  get layerAttributes(): LayerAttributesArray {
    if (!this.data) {
      return;
    }
    return this.data.layerAttributes;
  }
  set layerAttributes(atts: LayerAttributesArray) {
    if (!this.data) {
      return;
    }
    this.data.layerAttributes = atts;
    this.change$.emit(this);
  }
  get exportOptions(): LayerExportOptionsArray {
    return this.data.exportOptions;
  }
  set exportOptions(opts: LayerExportOptionsArray) {
    this.data.exportOptions = opts;
    this.change$.emit(this);
  }
  get geom(): string {
    return this.data.geom;
  }
  set geom(geom: string) {
    this.data.geom = geom;
    this.change$.emit(this);
  }
  get id(): string {
    return this.data.id;
  }
  get layerOn(): boolean | null {
    if (this.isPLayer === false) {
      return true;
    }
    if (!!this.data) {
      if (this.parentLayer !== '') {
        if (!this.parentVis) {
          return false;
        }
      }
      return '' + this.data.layer_on === '1';
    } else {
      return false;
    }

  }
  get customData() {
    return this.data.custom_data;
  }
  set layerOn(isOn: boolean) {
    this.SetLayerOn(isOn, this.SLMap);
  }
  get layerVis(): boolean {
    if (!this.data) {
      return false;
    }

    return ('' + this.data.layer_on) === '1';
  }
  set layerVis(layerOn: boolean) {
    if (!this.data) {
      return;
    }
    this.data.layer_on = layerOn ? '1' : '0';
    this.SetLayerOn(this.layerVis, this.map);
  }

  GetLayerVis(): boolean {
    return this.layerVis;
  }
  SetLayerOn(isOn: boolean, map: ISLMap) {
    if (this.data === null) {
      return;
    }
    // const wasOn = this.layerOn;
    this.data.layer_on = isOn ? '1' : '0';
    this.UpdateSubVis();
    if (isOn && this.touched && this.parentVis) {
      this.Render(map);
      this.touched = false;
    } else {
      if (this.overlayLayer === undefined) {
        this.Render(map);
      } else {
        try {
          this.overlayLayer.UpdateVisibility();
          // map.ui.getLayer(this.overlayLayer.id);
          // map.ui.setLayoutProperty(this.overlayLayer.ui.id, 'visibility', (isOn && this.parentVis) ? 'visible' : 'none');
        } catch (e) {
          // this.Render(map);
          // do nothing;
        }
      }
      if (this.parentLayer !== '' && (this.parentVis === false)) {
        this.touched = true;
      }
    }
    this.visChange.emit({ layer: this });
  }


  get parentVis(): boolean {
    if (this.parentLayer === '') {
      if (this.isPLayer === false) { return true; }
      return this.GetLayerVis();
      // return ('' + this.data.layer_on) === '1';

    }

    const parent = this.SLMap.GetLayerById(this.parentLayer, this.isPLayer);
    if (parent) {
      return parent.parentVis;
    }
    if (!this.data) {
      return false;
    }
    return ('' + this.data.layer_on) === '1';
  }
  UpdateSubVis() {
    if (this.subLayers) {
      for (const sub of this.subSLLayers) {
        if (!sub) {
          continue;
        }
        if (!!sub.overlayLayer) {
          sub.overlayLayer.UpdateVisibility();

          if (sub.layerOn === true) {
            if (sub.touched === true) {
              sub.Render();
            }
          }
          sub.visChange.emit({ layer: sub });
          sub.UpdateSubVis();
        }
      }
    }
  }

  get includeInLegend(): boolean {
    const allowedGeomTypes = ['collection', 'point', 'polygon', 'line'];
    if (allowedGeomTypes.indexOf(this.geom) < 0) {
      if (!this.IsVirtual()) {
        return false;
      }
    }
    const parent = this.parentSLLayer;

    if (!!parent && parent.includeInLegend === false) return false;
    if (!!this.data && this.data.hasOwnProperty('includeInLegend') === false) {
      this.data.includeInLegend = 't';

    }
    return (!!this.data) ? this.data.includeInLegend === 't' : false;
  }
  set includeInLegend(include: boolean) {
    if (!this.data) {
      return;
    }
    this.data.includeInLegend = include ? 't' : 'f';
    this.legendChange.emit({ layer: this });
    this.change$.emit(this);
  }

  get labelsOn(): boolean | null {
    if (this.isPLayer === false) {
      return null;
    }
    if (!!this.data) {
      return '' + this.data.labels.labels_on === '1';

    }
    return null;
  }
  set labelsOn(isOn: boolean) {
    if (this.isPLayer === false) {
      return;
    }
    if (!this.data) {
      return;
    }
    this.data.labels.labels_on = isOn ? '1' : '0';
    this.change$.emit(this);
  }
  get labelAttribute(): string {
    if (this.isPLayer === false) {
      return null;
    }
    if (!this.data) {
      return '';
    }
    if (!!this.data.labels) {
      if (!!this.data.labels.attribute) {
        return this.data.labels.attribute;
      }
    }
    return '';
  }
  set labelAttribute(att: string) {
    if (!this.data) {
      return;
    }
    if (this.isPLayer === false) {
      return;
    }
    if (!!this.data.labels) {
      this.data.labels.attribute = att;
      this.change$.emit(this);
    } else {
      this.data.labels = {} as any;
      this.data.labels.attribute = att;
    }

  }
  get labelStyle(): LabelStyle {
    if (this.isPLayer === false) {
      return null;
    }
    if (!!this.data?.labels) {
      if (!!this.data.labels.label_style) {
        if (this.data.labels.label_style === '') {
          return '';
        } else {
          return JSON.parse(this.data.labels.label_style) as LabelStyle;
        }
      }
    }
    return '';
  }
  set labelStyle(style: LabelStyle) {
    if (this.isPLayer === false) {
      return;
    }
    if (!this.data) {
      return;
    }
    if (!!this.data.labels) {
    } else {
      this.data.labels = {} as any;
    }
    if (style === '') {
      this.data.labels.label_style = '';
    } else {
      this.data.labels.label_style = JSON.stringify(style);
    }
    this.change$.emit(this);
  }
  get lastLoadedLabelState(): LayerLabelState | null {
    if (!this.originalLabelState) {
      return null;
    }
    return this.CloneLabelState(this.originalLabelState);
  }
  get labelStyleJSON(): string {
    if (!this.data?.labels?.label_style) return '';
    return this.data?.labels?.label_style;
  }
  private CloneLabelStyle(style: LabelStyle): LabelStyle {
    if (style === '' || style === null || style === undefined) {
      return '';
    }
    return JSON.parse(JSON.stringify(style)) as LabelStyle;
  }
  private CloneLabelState(state: LayerLabelState): LayerLabelState {
    return {
      labelsOn: state.labelsOn,
      labelAttribute: state.labelAttribute,
      labelStyle: this.CloneLabelStyle(state.labelStyle),
      labelOverride: state.labelOverride
    };
  }
  CaptureLabelState(): void {
    if (this.IsVirtual()) {
      this.originalLabelState = null;
      return;
    }
    this.originalLabelState = {
      labelsOn: this.labelsOn,
      labelAttribute: this.labelAttribute,
      labelStyle: this.CloneLabelStyle(this.labelStyle),
      labelOverride: this.labelOverride
    };
  }
  RestoreLabelState(): void {
    if (this.IsVirtual() || !this.originalLabelState) {
      return;
    }
    const state = this.CloneLabelState(this.originalLabelState);
    if (this.isPLayer) {
      this.labelsOn = state.labelsOn;
      this.labelAttribute = state.labelAttribute;
      this.labelStyle = state.labelStyle;
    }
    this.labelOverride = state.labelOverride;
    this.change$.emit(this);
  }
  get plid(): string {
    if (!this.data) {
      return null;
    }
    if (this.data.hasOwnProperty('plid') === false) {
      return null;
    }
    return this.data.plid;
  }
  get name(): string {
    if (!this.data) {
      return '';
    }
    return this.data.name;
  }
  set name(name: string) {
    if (!this.data) {
      return;
    }
    this.data.name = name;
    this.change$.emit(this);
  }
  get opacity(): number {
    if (!!this.data) {
      return Number.parseFloat(this.data.opacity);
    }
    return 0;
  }
  set opacity(o: number) {
    if (!this.data) {
      return;
    }
    this.data.opacity = o;

    this.overlayLayer.UpdateOpacity();
    if (this.isPLayer) {
      if (this.hasSubLayers) {

        this.UpdateSubOpacity(this.subSLLayers);
      }

    }
  }
  UpdateSubOpacity(layers: Array<SLLayer>) {
    for (const layer of layers) {
      layer.overlayLayer.UpdateOpacity();
      if (layer.hasSubLayers) {
        if (layer.subLayers.length > 0) {
          this.UpdateSubOpacity(layer.subSLLayers);
        }
      }
    }
  }
  get parentOpacity(): number {
    if (this.parentLayer === '') {
      if (this.isPLayer === false) { return 1; }
      return this.opacity;
    }
    const parent = this.SLMap.GetLayerById(this.parentLayer, this.isPLayer);
    return parent.opacity;
  }
  SetOpacity(o: number, map: SLMap) {
    map = map;
    if (!this.data) {
      return;
    }
    this.data.opacity = o;
    this.overlayLayer.UpdateOpacity();
  }
  get owner(): string {
    return this.data?.owner;
  }
  set owner(owner: string) {
    if (!this.data) {
      return;
    }
    this.data.owner = owner;
    this.change$.emit(this);
  }
  get ownerName(): string {
    return this.data?.owner_name;
  }
  set ownerName(name: string) {
    if (!this.data) {
      return;
    }
    this.data.ownerName = name;
    this.change$.emit(this);
  }
  get ownerDisplay(): string {
    return this.data.owner_display;
  }

  get searchTip(): string {
    return (this.data?.searchTip === null) ? '' : this.data?.searchTip;
  }
  set searchTip(tip: string) {
    if (!this.data) {
      return;
    }
    this.data.searchTip = (tip === '') ? null : tip;
    this.change$.emit(this);
  }
  get subLayers(): Array<any> | null {
    if (this.isPLayer === false) {
      return null;
    }
    if (!this.data) {
      return null;
    }
    if (this.data.hasOwnProperty('sublayers') === false) {
      return null;
    }
    return this.data.sublayers;
  }
  get subSLLayers(): Array<SLLayer> {
    const layers: Array<SLLayer> = [];
    if (!!this.subLayers) {
      for (const layer of this.subLayers) {
        layers.push(this.SLMap.GetLayerById(this.isPLayer ? layer.plid : layer.id, this.isPLayer));
      }
      return layers;
    }
    return [];
  }
  get hasSubLayers(): boolean {
    if (this.subLayers !== null) {
      return true;
    }
    return false;
  }

  get tooltip(): string {
    if (this.isPLayer) {
      return this.data.tooltip.value;
    }
    return this.data.tooltip;
  }
  set tooltip(tip: string) {
    if (!this.data) {
      return;
    }
    if (this.isPLayer) {
      this.data.tooltip.value = tip;
      return;
    }
    this.data.tooltip = tip;
    this.change$.emit(this);
  }
  get tooltipOn(): boolean | null {
    if (!this.isPLayer) {
      return null;
    }
    if (!(!!this.data)) {
      return false;
    }
    if (!(!!this.data.tooltip)) {
      return false;
    }
    if (!(!!this.data.tooltip.tooltip_on)) {
      if (this.data.tooltip.tooltip_on !== 0) {
        return false;
      }
    }
    return '' + this.data.tooltip.tooltip_on === '1';
  }
  set tooltipOn(isOn: boolean) {
    if (!this.isPLayer) {
      return;
    }
    if (!this.data) {
      return;
    }
    this.data.tooltip.tooltip_on = isOn ? '1' : '0';
    this.change$.emit(this);

  }
  get richTooltip(): string {
    if (!!this.data?.rich_tooltip) {
      return this.data?.rich_tooltip;
    }
    return '';
  }
  set richTooltip(tt: string) {
    if (!this.data) {
      return;
    }
    this.data.rich_tooltip = tt;
  }
  get tags(): Array<string> {
    if (!this.data) {
      return [];
    }
    if (!this.data.tags) return [];
    return this.data.tags.split(',');
  }
  set tags(tags: Array<string>) {
    if (!this.data) {
      return;
    }
    this.data.tags = tags;
    this.change$.emit(this);
  }
  get type(): number {
    if (!this.data) {
      return -1;
    }
    return parseInt(this.data.type, 10);
  }
  set type(layerType: number) {
    if (!this.data) {
      return;
    }
    this.data.type = layerType;
    this.change$.emit(this);
  }
  get typeString(): string {
    if (!this.data) {
      return '';
    }
    if (this.isPLayer) {
      return this.data.typeLabel;
    }
    return LayerTypeEnum[this.data.type];
  }

  get icon(): string {
    return SLLayer.GetIcon(this.geom);
  }
  set icon(newIcon: string) {
    if (!this.data) {
      return;
    }
    this.data.icon = newIcon;
    this.iconChange.emit(this.icon);
  }
  get fontIcon(): string | null {
    if (this.hasSubLayers === true) {
      return 'fas fa-layer-group'
    }
    return null;
  }
  get preferredView(): string {
    return 'layer';
  }
  get z(): number {
    if (!this.data) {
      return 0;
    }
    return this.data.z;
  }
  get absZ(): number {
    return Math.abs(this.z);
  }
  get parentLayer(): string {

    if (this.data?.parentLayer) {
      return this.data.parentLayer;
    }
    return '';

  }
  get parentSLLayer(): SLLayer | null {
    if (this.parentLayer === '') {
      return null;
    }
    return this.SLMap.GetLayerById(this.parentLayer, this.isPLayer);
  }

  get identifier() {
    if (this.isPLayer === true) {
      return this.plid;
    }
    return this.id;
  }

  get renderId(): string {
    return this.identifier;
  }
  public renderedLayer?: RenderedLayer;

  get hasGallery() {
    for (const attribute of this.layerAttributes) {
      if (attribute.casting?.entry?.mediaValue) {
        return true;
      }
    }
    return false;
  }

  Render(map: ISLMap = null, force = false) {
    if(this.filterField !== '') {
      if(this.filterIds.length === 0) {
        this.Clear();
        return;
      }
    }
    if (!!this.lastRender) {
      // this.lastRender.abort();
      this.lastRender = undefined;
      this._rendering = false;
    }

    if (this.SLMap.ui.moving) {
      this.touched = true;
      this._rendering = '1';
      // return;
    }
    if ((!this.layerOn || !this.parentVis) && !( force) ) {
      return;
    }

    if (!map) {
      map = this.SLMap;
      if (!map) return;
    }

    const finish = () => {
      if (this.lastRender && this.lastRender.id === this._rendering) {
        this._rendering = false;
        this.lastRender = undefined;
      }
    };

    const handler = (result: LayerRenderResult) => {
      if (this.lastRender && this.lastRender.id !== this._rendering) {
        //return;
      }
      // if (this.SLMap.moving) return;
      // if (this.lastRender && this.lastRender.aborted) return;
      this.renderedLayer = result?.image;
      this.overlayLayer?.HandleRenderResult(result);
      this.rendered.emit({ id: this.identifier, isPLayer: this.isPLayer, status: 'ok' });

    };

    const errorHandler = () => {
      if (this.lastRender && this.lastRender.id !== this._rendering) {
        return;
      }

      this.rendered.emit({
        id: this.identifier,
        isPLayer: this.isPLayer,
        status: 'problem',
        error: 'There was a problem rendering layer: ' + this.name
      });

    };

    try {
      this.touched = false;
      const labelStyle = this.labelStyleJSON;
      const labelOverride = this.labelOverride;
      const renderStyles: any = {};
      if (!!labelStyle && labelStyle !== '') {
        renderStyles.labelStyle = labelStyle;
      }
      if (!!labelOverride && labelOverride !== '') {
        renderStyles.labelOverride = labelOverride;
      }
      if (this.isPLayer) {
        this.lastRender = this.layerService.RenderProjectLayerById(
          Number(this.plid),
          map,
          this.filterIds ?? [] as any,
          renderStyles
        );

      } else {
        this.lastRender = this.layerService.RenderLayerById(
          Number(this.id),
          map,
          this.filterIds ?? [] as any,
          renderStyles
        );
      }
      if (this.lastRender) {
        this._rendering = this.lastRender.id;
      } else {
        this._rendering = false;
      }

      if (!!this.lastRender) this.lastRender.then(handler).catch(errorHandler).finally(finish);
      this.rendering.emit({ id: this.identifier, isPLayer: this.isPLayer });

    } catch (e) {
      errorHandler();
    }
  }
  GetTooltipText(featureData: any, rich: boolean = true): string {

    let tooltipText = rich ? this.richTooltip : this.tooltip;
    for (const fieldName in featureData) {
      if (featureData.hasOwnProperty(fieldName)) {
        let fieldValue = featureData[fieldName];

        const fieldInfo: AttributeInfo = this.GetAttribute(fieldName);
        if (!!fieldInfo) {
          if (fieldValue === null) {
            fieldValue = '';
          }
          const rawValue = AttributesService.GetValue(fieldInfo, fieldValue);
          fieldValue = AttributesService.GetDisplayValue(fieldInfo, rawValue);

          while (tooltipText.indexOf('[' + fieldName + ']') > -1) {
            tooltipText = tooltipText.replace('[' + fieldName + ']', fieldValue);
          }
        }
      }
    }
    // tooltipText = tooltipText.replace(`\n`, '<br>');
    return tooltipText;
  }


  ZoomToFeatures(optFeatures?: Array<any>) {
    const visArea = this.SLMap.src?.panelSet?.GetVisibleArea();
    const mapWidth = (this.SLMap.ui.getCanvas() as HTMLCanvasElement).width;
    const mapHeight = (this.SLMap.ui.getCanvas() as HTMLCanvasElement).height;

    if (!!optFeatures) {
      this.layerService.FeatureZoom(this, optFeatures).then((result) => {
        const bbox = result.response?.bbox?.split(',');
        if (!bbox) return;
        if (bbox.length == 2) {
          const loc: GeoLoc = {
            point: { lng: bbox[0], lat: bbox[1] }
          }
          NavigationAction.JumpToGeoLoc(this.SLMap.component, loc);
          return;
        }
        const fbounds = this.layerService.LayerExtsToLngLatBounds(result.response.bbox.split(','));
        this.SLMap.ui.fitBounds(fbounds, { animate: false, });
        if (visArea) {
          this.SLMap.ui.fitScreenCoordinates(new Point(-(1.5 * visArea.primary) - 64, -64), new Point(mapWidth + (1.5 * visArea.secondary) + 64, mapHeight + (1.5 * visArea.extended) + 64), 0, { animate: false });

        } else {
          this.SLMap.ui.fitScreenCoordinates(new Point(-64, -64), new Point(mapWidth + 64, mapHeight + 64), 0, { animate: 0 });
        }
      });
      return;
    }
    const bounds = this.layerService.LayerExtsToLngLatBounds(this.bbox as BBOXArray);
    this.SLMap.ui.fitBounds(bounds, { animate: false });
    if (visArea) {
      this.SLMap.ui.fitScreenCoordinates(new Point(-(1.5 * visArea.primary) - 64, -64), new Point(mapWidth + (1.5 * visArea.secondary) + 64, mapHeight + (1.5 * visArea.extended) + 64), 0, { animate: false });
      //this.SLMap.ui.fitScreenCoordinates(visArea[0], visArea[1], 0, { animate: false });
    } else {
      this.SLMap.ui.fitScreenCoordinates(new Point(-64, -64), new Point(mapWidth + 64, mapHeight + 64), 0, { animate: 0 });
    }

  }

  CloneData() {
    if (!this.data) return null;
    return JSON.parse(JSON.stringify(this.data));
  }
  PromptSave() {

    this.layerService.PromptSave(() => {
      this.touched = true;
      this.Render();
    }, this);
  }
  Save(options: LayerSaveOptions): CancellablePromise {
    return this.layerService.UpdateLayer(this, options);
  }
  PromptLoad() {
    this.layerService.PromptLoad(() => {

    }, this);
  }
  Load(options: LayerLoadOptions): CancellablePromise {
    return this.layerService.LoadLayer(this, options);
  }
  PromptExport() {
    this.layerService.PromptExport(this);
  }
  Remove() {
    if (!!this.overlayLayer) {
      this.overlayLayer.Remove();
    }
    delete this.SLMap;

  }
  DecorateSettings(mergeObject: any): void {
    mergeObject.opacity = this.opacity;
    mergeObject.labels_on = this.labelsOn ? 1 : 0;
    mergeObject.attribute = this.labelAttribute;
    mergeObject.layer_on = this.GetLayerVis() ? 1 : 0; // this.layerOn ? 1 : 0;
  }
  UpdateLegend() {


    if (this.includeInLegend === true) {
      this.includeInLegend = false;
      setTimeout(() => {
        this.includeInLegend = true;
      }, 50);
    } else {
      this.legendChange.emit({ layer: this });
    }
  }
  RemoveFromProject(handler: AnyHandler) {
    if (this.isPLayer === false) {
      return;
    }
    if (!this.layerService) {
      return;
    }
    if (!this.SLMap.component.layersAPI) {
      return;
    }
    this.SLMap.component.layersAPI.RemoveLayerFromProject(this.SLMap.project.id, this.plid).then((response: any) => {
      response = response;
      let i = -1;
      const plid = this.plid;
      for (const layer of this.SLMap.project.layers) {
        i++;
        if (layer.plid === this.plid) {
          this.SLMap.project.layers.splice(i, 1);
          this.SLMap.RemoveMapLayer(plid);
          this.Remove();

          handler(plid);
          return;
        }
      }


      this.Remove();
      handler(plid);
    });

  }
  SetSelections(_selections: ISelectionData, _inputType: 'rect' | 'point' | 'feature' = null) {
    // do nothing;
  }
  GetAttribute(attName: string): AttributeInfo {
    for (const attribute of this.layerAttributes) {
      if (attribute.name === attName) {
        return attribute;
      }
    }
  }
  IsVirtual(id: number = 9000) {
    if (id === 9000) {
      return Number(this.type) >= 9000;
    } else {
      return Number(this.type) === id;
    }
  }
  IsVirtualSearchResultSubLayer(): boolean {
    return SLLayer.VIRTUAL_SEARCH_RESULT_SUBLAYERS.indexOf(Number(this.type)) > -1;
  }
  GetEmptyRecord(): any {
    const atts = this.layerAttributes;
    const record: any = {};
    for (const att of atts) {
      if (att.name === 'gid') {
        continue;
      }
      record[att.name] = null;
    }
    if (record.hasOwnProperty('the_geom') === false) {
      record.the_geom = null;
    }
    return record;
  }
  GetEmptyFeatureInfo(): FeatureInfo {
    return {
      count: 1,
      feature: this.GetEmptyRecord(),
      index: 0,
      layer: this
    }
  }
  Touch(isTouched = true) {
    this.touched = isTouched;
  }
  GetExportableAttributes(_visOnly = true) {
    const session = SlWapiService.SLSESSION;
    const attributes = this.layerAttributes;
    const exportable = [];
    for (const attribute of attributes) {
      if (!AttributesService.IsVisible(attribute)) {
        continue;
      }
      if (!!attribute.export && (attribute.export.allow === false)) {
        continue;
      } else if (!!attribute.export && (attribute.export.reqAuth === true)) {
        if (session.isAuthorized === false) {
          continue;
        }
      }

      exportable.push(attribute.name);


    }
    return exportable;
  }
  SetLabelInfo(_info: any) {
    return;
  }
  GetLabelInfo(): any {
    return null;
  }
  HasFeatures() {
    return false;
  }

  GetColor() {
    return '';
  }
  GetSourceLayer() {
    return null;
  }
  GetDataURL() {
    if (!!this.overlayLayer) {
      this.overlayLayer
    }
  }
  Clear() {
    if(!this.overlayLayer) return;
    this.overlayLayer.Clear();
    this.touched = true;
  }

}
